module.exports = __webpack_public_path__ + "img/Splunk.b82ccaa.svg";